import { useMemo } from 'react';
import { gql } from '@apollo/client';
import { useGraphql } from 'utils/hooks/useGraphql';
import { Placement, PlacementGraphQLDef } from '../types';

export const FetchPlacementsQuery = gql`
  query FetchPlacements($nonArchivedOnly: Boolean) {
    placements(nonArchivedOnly: $nonArchivedOnly) {
      payload {
        createdAt
        creatorUserId
        id
        isArchived
        fields {
          placementName
          description
          mediaLayout
          campaignLimit
          hasTitle
          hasBody
          hasMedia
          hasDataFeeds
          hasOpenAction
          actionButtons {
            title
            action {
              type
              data
            }
          }
          payload
          destinations
          textFields
        }
      }
    }
  }
`;

export const useQueryPlacements = (nonArchivedOnly = true) => {
  const { data, isLoading, errorMessage } = useGraphql(FetchPlacementsQuery, {
    variables: {
      nonArchivedOnly,
    },
  });

  const placements = useMemo<Placement[]>(
    () =>
      data?.placements
        ?.map(
          (placementDef: PlacementGraphQLDef): Placement => ({
            ...placementDef.payload.fields,
            id: placementDef.payload.id,
            isArchived: placementDef.payload.isArchived,
            createdAt: new Date(placementDef.payload.createdAt.timestamp.replace(/\[.*\]/, '')),
            createdBy: placementDef.payload.creatorUserId,
          }),
        )
        .sort((a: { createdAt: number }, b: { createdAt: number }) => b.createdAt - a.createdAt) || // Sort from newest to oldest
      [],
    [data],
  );

  return {
    placements,
    loading: isLoading,
    error: errorMessage,
  };
};
